import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import useNavigationPage from '../../../hooks/useNavigationPage';
import { IncidentReasonDataForm, defaultIncidentReasonDataForm } from '../../../app/models/IncidentReason';
import useIncidentReasonService from '../../../app/services/hooks/useIncidentReasonService';
import IncidentReasonForm from './forms/IncidentReasonForm';

interface Props {
    incidentReasonId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const IncidentReasonEdit = ({ incidentReasonId, onSaved, onCancel, onError }: Props) => {

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { navigationPage } = useNavigationPage();

    const { fetchingEditIncidentReason, fetchingUpdateIncidentReason, editIncidentReason, updateIncidentReason } = useIncidentReasonService();

    const [incidentReason, setIncidentReason] = useState<IncidentReasonDataForm>(defaultIncidentReasonDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando feriado...');
        editIncidentReason(incidentReasonId, {
            onSuccess: (response: ServiceResponse) => {
                setIncidentReason(response.data.incident_reason);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };


    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando motivo de incidencia...');
        updateIncidentReason(incidentReasonId, incidentReason, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditIncidentReason ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <IncidentReasonForm
                        incidentReasonForm={incidentReason}
                        setIncidentReasonForm={setIncidentReason}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingUpdateIncidentReason} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} locked={fetchingUpdateIncidentReason} />
                </div>
            </div>
        </>
    )
}

export default IncidentReasonEdit
